import { GetUsersCountFailure } from '@store/broadcast-messages/features/get-users-count/get-users-count-failure';
import { GetUsersCountSuccess } from '@store/broadcast-messages/features/get-users-count/get-users-count-success';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';
import { AxiosResponse } from 'axios';
import {
  ICountForBroadcastResponse,
  IGetCountOfUsersByFilter,
} from 'lingopractices-models/src/main';
import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { createDeferredAction } from '../../../common/actions';
import { httpRequestFactory } from '../../../common/http-request-factory';
import { HttpRequestMethod } from '../../../common/http-request-method';
import { MAIN_API } from '../../../common/path';

export class GetUsersCount {
  static get action() {
    return createDeferredAction<IGetCountOfUsersByFilter>('broadcastMessages/GET_USERS_COUNT');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.getUserCountPending = true;
      return draft;
    };
  }

  static get saga() {
    return function* ({ payload, meta }: ReturnType<typeof GetUsersCount.action>): SagaIterator {
      try {
        const response = GetUsersCount.httpRequest.call(
          yield call(() => GetUsersCount.httpRequest.generator(payload)),
        );

        const {
          data: { count },
        } = response;

        if (typeof count === 'number') {
          yield put(GetUsersCountSuccess.action(count));

          meta?.deferred.resolve(count);
        }
      } catch (e) {
        yield put(GetUsersCountFailure.action());
        meta?.deferred.reject(e);
      }
    };
  }

  static get httpRequest() {
    return httpRequestFactory<AxiosResponse<ICountForBroadcastResponse>, IGetCountOfUsersByFilter>(
      MAIN_API.BROADCAST_MESSAGES_COUNT,
      HttpRequestMethod.Post,
    );
  }
}
